window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.superBotRepo = (function () {
    var url = "api/casinosuperbot";

    var get = function () {
        return fetch(url)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    };
})();